import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import PageHeading from "../components/styled/page-heading"

import './index.css'
import './login.css'

//put most popular content on this page as an argument, free from login
const IndexPage = () => {
  const seo = { title: "Homepage"}

  

  return (
    <div id="lay">
      <Layout>
        <SEO seo={seo} />
        <h1 className="tit" id="hometit">Welcome to the ONEGROWio Beta!</h1>
        <br/><br/>
 
        <Link to="/login/" id="loglink">
          <div id="loglinkbox">Get Started!</div>
        </Link> <br />
        

      </Layout>
    </div>
  )
}


export default IndexPage
